exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.permission-container[data-v-37c90f0e] {\n  overflow: hidden;\n}\n.permission-tips[data-v-37c90f0e] {\n  margin-top: 200px;\n  font-size: 36px;\n  font-weight: bold;\n  text-align: center;\n  color: #409eff;\n}\n.permission-btn[data-v-37c90f0e] {\n  display: block;\n  width: 100px;\n  margin: 50px auto 0;\n  padding: 3px 5px;\n  color: #fff;\n  border-radius: 3px;\n  text-align: center;\n  cursor: pointer;\n}\n", ""]);

// exports
